// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Calendar: 'التقويم',
  'Add Visit': 'إضافة زيارة',
};
